export default "__VITE_ASSET__DyoiW7QO__"